import { styled } from '@mui/system';

export const GridContainer = styled('section')`
  margin: 0 16px 16px 16px;
  height: 100%;
  display: flex;
  width: 100%;
`;
